import { RecaptchaProvider } from '@core/utils/contexts/RecaptchaProvider/RecaptchaProvider'

import { Suspense, lazy, useEffect, useState } from 'react'

import { Box } from '@chakra-ui/react'

const NotAuthorized = lazy(() => import('@page/post/components/ApplyJob/NotAuthorized/NotAuthorized'))
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { useGetPostSettingsQuery } from '@core/app/api/postsApi'
import { RECAPTCHA } from '@core/utils/constants/constants'
import { useIsApplyDialog } from '@core/utils/contexts/ApplyDialogContext/ApplDialogContext'
import { getLocalStorageItem } from '@core/utils/helpers/localStorageHelpers'
import useLocalStorageStore from '@core/utils/hooks/useLocalStorageStore'
import i18n from '@core/utils/i18n'

import { Attributes } from '@page/post/components/ApplyJob/Attributes/Attributes'

const baseClassName = 'ApplyJobBlock'

export const ApplyJobBlock = (): JSX.Element => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const [serviceCode, setServiceCode] = useLocalStorageStore('service_code')
    const postId = location.pathname.includes('/job/')
        ? id
        : //     : localStorage.getItem('apply_dialog') && JSON.parse(localStorage.getItem('apply_dialog')!).id
          getLocalStorageItem('apply_dialog')?.id

    const {
        data: settings,
        isLoading: isSettingsLoading,
        isFetching: isSettingsFetching,
        isError: isSettingsError,
    } = useGetPostSettingsQuery(
        {
            id: postId || '',
            // @ts-ignore
            code: serviceCode,
            // path: localStorage.getItem('apply_path') ? `${localStorage.getItem('apply_path')}` : '',
            path: '',
        },
        { skip: !postId }
    )
    const { close } = useIsApplyDialog()
    const isApplyOnly = location.href.includes('apply_only')

    useEffect(() => {
        const service_code = searchParams.get('code')
        // const path = searchParams.get('path')

        // if (path) {
        //     localStorage.setItem('apply_path', path)
        // } else {
        //     localStorage.removeItem('apply_path')
        // }

        if (service_code) {
            setServiceCode(service_code)
            navigate(
                {
                    search: isApplyOnly ? '?apply_only' : '',
                },
                { replace: true }
            )
        }
    }, [searchParams])

    useEffect(() => {
        if (settings?.redirectUrl) {
            location.href = settings.redirectUrl
        }

        if (settings && (settings?.isApplicationExist || (isApplyOnly && !settings?.isUser))) {
            close()
        }
    }, [settings, isApplyOnly])

    useEffect(() => {
        if (isSettingsError) {
            close()
        }
    }, [isSettingsError])

    useEffect(() => {
        if (postId) {
            window.dispatchEvent(
                new CustomEvent('ra-button-job-post-action-apply-now', {
                    detail: {
                        job_post_id: postId,
                    },
                })
            )
        }
    }, [postId])

    return (
        // <GoogleReCaptchaProvider
        //     reCaptchaKey={RECAPTCHA}
        //     useEnterprise={true}
        //     language={i18n.language}
        // >
        <RecaptchaProvider>
            <Box w={'full'} bg={'bg.1'} borderRadius={'8px'} className={baseClassName}>
                {settings?.isUser && (id || getLocalStorageItem('apply_dialog')?.id) && (
                    <Attributes
                        id={location.pathname.includes('/job/') ? id : getLocalStorageItem('apply_dialog')?.id}
                        settings={settings}
                        isSettingsLoading={isSettingsLoading}
                        isSettingsFetching={isSettingsFetching}
                    />
                )}
                {!settings?.isUser && settings?.redirectUrl === undefined && (
                    <Suspense fallback={<div>Loading...</div>}>
                        <NotAuthorized
                            settings={settings}
                            isSettingsLoading={isSettingsLoading}
                            isSettingsFetching={isSettingsFetching}
                        />
                    </Suspense>
                )}
            </Box>
        </RecaptchaProvider>
        // </GoogleReCaptchaProvider>
    )
}
